import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";

import yup from "../../utils/yup";
import Form from "../../components/form/Form";
import { getMe, updateMe } from "../../services/UserService";
import ChangePasswordFormModal from "./ChangePasswordFormModal";
import SecondaryButton from "../../components/SecondaryButton";
import { PAYMENT_PLANS, Roles } from "../../utils/constants";
import { convertDate } from "../../utils/utils";
import { cancelSubscription } from "../../services/PaymentService";

const Profile = () => {
  const [user, setUser] = useState(null);
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const [formDetails, setFormDetails] = useState({
    schema: null,
    steps: null,
  });

  const form = useForm({
    resolver: yupResolver(formDetails.schema),
    mode: "onChange",
  });

  useEffect(() => {
    getMe().then((data) => setUser(data));
  }, []);

  useEffect(() => {
    if (user) {
      setFormDetails({
        steps: {
          submitButtonLabel: "Submit",
          steps: [
            {
              name: "first_name",
              label: "First name",
              type: "text",
            },
            {
              name: "last_name",
              label: "Last name",
              type: "text",
            },
            {
              name: "email",
              label: "E-mail",
              disabled: user?.email !== null,
              type: "text",
            },
            {
              name: "phone_number",
              disabled: user?.phone_number !== null,
              label: "Phone number",
              type: "text",
            },
          ],
        },
        schema: yup
          .object()
          .shape({
            first_name: yup
              .string()
              .typeError("The first name is not valid.")
              .min(2, "The first name must be larger than 2 characters.")
              .nullable(),
            last_name: yup
              .string()
              .typeError("The first name is not valid.")
              .min(2, "The first name must be larger than 2 characters.")
              .nullable(),
            email: yup
              .string()
              .email("The email is not valid.")
              .typeError("The first name is not valid.")
              .nullable(),
            phone_number: yup
              .string()
              .typeError("The phone number is not valid.")
              .test(
                "phone-number-check",
                "The phone number is not valid.",
                (val) =>
                  !val ||
                  RegExp(
                    "^((\\+[1-9]{1,4}[ -]?)|(\\([0-9]{2,3}\\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$"
                  ).test(val)
              )
              .nullable(),
          })
          .required(),
      });

      Object.keys(user).map((key) => {
        form.setValue(key, user[key]);
      });
    }
  }, [user]);

  const onSubmit = (values) => {
    updateMe(form.setError)(values).then((data) => {
      setUser(data);
      toast.success("Your profile has been updated");
    });
  };

  const handleCancelSubscription = () => {
    cancelSubscription().then(() => {
      const storage = JSON.parse(localStorage.getItem("availabilityTracker"));
      localStorage.setItem(
        "availabilityTracker",
        JSON.stringify({
          ...storage,
          user: { ...storage.user, is_payment_active: false },
        })
      );
      location.reload();
    });
  };

  return (
    user && (
      <div>
        <Form formDetails={formDetails.steps} form={form} onSubmit={onSubmit} />
        <ChangePasswordFormModal
          open={changePasswordOpen}
          onClose={() => setChangePasswordOpen(false)}
        />
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <SecondaryButton onClick={() => setChangePasswordOpen(true)}>
            Change password
          </SecondaryButton>
        </div>

        {user.role === Roles.EMPLOYER.value && (
          <div>
            <h5>Payment Information</h5>
            <div>
              <h6>
                Current Subscription Plan:{" "}
                {PAYMENT_PLANS[user.payment_plan]?.label}
              </h6>
              {user.payment_plan === PAYMENT_PLANS.SUBSCRIPTION.value && (
                <div>
                  <h6>
                    Valid until: {convertDate(new Date(user.subscription_end))}
                  </h6>
                  <h6>This subscription will automatically renew.</h6>
                  <div>
                    <SecondaryButton onClick={handleCancelSubscription}>
                      Cancel Subscription
                    </SecondaryButton>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    )
  );
};

export default Profile;
